import axios from 'axios';

import { GET_PDSN_RATING, GET_PDSN_REVIEWS, GET_PRODUCT_RATING, GET_PRODUCT_REVIEWS, GET_ALL_PRODUCT_RATINGS, RESET_REVIEWS, GET_ERRORS } from './types';

const pellaAPIURL = process.env.GATSBY_PELLA_API;

export const getPDSNRating = (branchId) => (dispatch) => {
	axios
		.get(`${pellaAPIURL}/ratings/summary/pdsn/${branchId}`)
		.then((res) =>
			dispatch({
				type: GET_PDSN_RATING,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const getProductRating = (productId) => (dispatch) => {
	axios
		.get(`${pellaAPIURL}/ratings/summary/product/${productId}`)
		.then((res) =>
			dispatch({
				type: GET_PRODUCT_RATING,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const getAllProductRatings = () => (dispatch) => {
	axios
		.get(`${pellaAPIURL}/ratings/summary/all-products`)
		.then((res) =>
			dispatch({
				type: GET_ALL_PRODUCT_RATINGS,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const getPDSNReviews = (branchId) => (dispatch) => {
	axios
		.get(`${pellaAPIURL}/ratings/pdsn/${branchId}`)
		.then((res) => {
			dispatch({
				type: GET_PDSN_REVIEWS,
				payload: res.data,
			});
		})
		.catch((err) => {
			dispatch({
				type: GET_ERRORS,
				payload: err,
			});
		});
};

export const getProductReviews = (productId) => (dispatch) => {
	axios
		.get(`${pellaAPIURL}/ratings/product/${productId}`)
		.then((res) =>
			dispatch({
				type: GET_PRODUCT_REVIEWS,
				payload: res.data,
			})
		)
		.catch((err) =>
			dispatch({
				type: GET_ERRORS,
				payload: err,
			})
		);
};

export const resetReviews = () => ({
	type: RESET_REVIEWS,
});
